import { useState } from 'react'

import { ProductCard as F1ProductCard } from '@factorialco/factorial-one-react'

import { track } from 'modules/core/lib/Tracking'
import { trackingEvents } from 'modules/core/lib/Tracking/events'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { useGetUpsellingData } from 'modules/upselling_kit/hooks/useGetUpsellingData'
import { UpsellingKitProductCard } from 'modules/upselling_kit/types'
import {
  handleUpsellingOnClick,
  handleUpsellingOnClose,
} from 'modules/upselling_kit/utils/handlers'
import { moduleIcons } from 'modules/upselling_kit/utils/moduleIcons'

import { ProductModal } from '../ProductModal'
import { UpsellGuard } from '../UpsellGuard'

const ProductCardContent = ({
  moduleRequested,
  title,
  description,
  dismissible,
  requestSource,
  onClick,
  onClose,
}: UpsellingKitProductCard) => {
  const { moduleName, moduleDescription } = useGetUpsellingData({
    moduleRequested,
    title,
    description,
  })

  const [openUpsellModal, setOpenUpsellModal] = useState(false)

  return (
    <>
      <F1ProductCard
        title={moduleName || ''}
        description={moduleDescription || ''}
        icon={moduleIcons(moduleRequested)}
        onClick={() =>
          handleUpsellingOnClick({
            onClick,
            requestSource,
            moduleRequested,
            component: 'product_card',
            setOpenUpsellModal,
          })
        }
        dismissable={dismissible}
        isVisible
        trackVisibility={(open: boolean) => {
          if (open) {
            track(trackingEvents.upsellingKit.viewedProductUpsellComponent, {
              source: requestSource,
              module: moduleRequested,
              component: 'product_card',
            })
          }
        }}
        onClose={() =>
          handleUpsellingOnClose({
            onClose,
            requestSource,
            moduleRequested,
            component: 'product_card',
          })
        }
      />
      {openUpsellModal && (
        <ProductModal
          requestReason={ValidReasons.MissingAddon}
          moduleRequested={moduleRequested}
          requestSource={requestSource}
          onClose={() => setOpenUpsellModal(false)}
          pageSource={requestSource}
          isOpen={openUpsellModal}
        />
      )}
    </>
  )
}

const ProductCard = ({
  title,
  description,
  dismissible,
  onClick,
  onClose,
  fallbackComponent,
  ...upsellProps
}: UpsellingKitProductCard) => {
  return (
    <UpsellGuard {...upsellProps} fallbackComponent={fallbackComponent || null}>
      <ProductCardContent
        {...upsellProps}
        title={title}
        description={description}
        dismissible={dismissible}
        onClick={onClick}
        onClose={onClose}
      />
    </UpsellGuard>
  )
}

export { ProductCard }
